import useEditor from "./useEditor";

export default useEditor;
